'use strict';

/**
 *
 * @name: addToQueue
 *
 */

function AddToQueueDirective($rootScope, $timeout, localPlaylist) {

  'ngInject';

  return {
    // TODO: change to ATTRIBUTE directive
    restrict: 'CA',
    replace: 'false',
    transclude: 'true',
    scope: {
      post: '=*',
      dontMutateButtons: '=*',
      analyticsLabel: '@',
      overlaySettings: '='
    },
    link: function(scope, element) {

      $(element).on('click', function(e) {

        e.preventDefault();

        if (!$(element).hasClass('js-queueDelete')) {

          $rootScope.analytics.buttons('add', scope.analyticsLabel, scope.post);

          localPlaylist
            .addBookmark(scope.post)
            .then(function() {

              if (!scope.overlaySettings) {

                scope.overlaySettings = {};
              }

              scope.overlaySettings.hasPlaylistOverlay = true;
              scope.overlaySettings.show = 'logIn';

              $timeout(function() {

                scope.overlaySettings.hasPlaylistOverlay = false;
              }, 3333);

              if (!scope.dontMutateButtons) {
                $(element).removeClass('js-queueAdd').addClass('js-queueDelete');
              }
            });

          scope.$emit('nowness.addToQueue');

        } else {
          localPlaylist
            .removeBookmark(scope.post)
            .then(function() {

              if (!scope.dontMutateButtons) {
                $(element).removeClass('js-queueDelete').addClass('js-queueAdd');
              }
            });
        }
      });
    }
  };
}

export default AddToQueueDirective;



// WEBPACK FOOTER //
// ./app/components/nn-bookmark/nn-add-to-queue.directive.js